import _ from "lodash";
import * as React from "react";
import { useDispatch } from "react-redux";

import { useDocumentPathForInput } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { DocumentServiceFactory, FieldInstanceValue } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { ReferenceColumn } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/overview-model";
import { TableBodyCell } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/table/sub-components/table-body-cell";
import { DefaultComponentMap } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/component-map";
import { Checkbox } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/checkbox";

import { assertNonNullable, assertTrue } from "../../utilities/assert";

import { ActivityIdContext } from "../ActivityContext";

import { updateOverviewDocument } from "./actions";
import { DocumentModelContext } from "./context";

const documentService = new DocumentServiceFactory().getDocumentService();

/**
 * A custom cell that shows a checkbox control for Boolean fields
 */
export function CustomTableBodyCell(readonly: boolean) {
	return function WrappedCustomTableBodyCell(props: TableBodyCell.Props) {
		assertTrue(ReferenceColumn.isAssignableFrom(props.columnModel));

		const documentModelContextValue = React.useContext(DocumentModelContext);
		assertNonNullable(documentModelContextValue);
		const { documentModel, documentModelSearchService } = documentModelContextValue;

		const dispatch = useDispatch();

		const activityId = React.useContext(ActivityIdContext);
		assertNonNullable(activityId);

		const path = documentModelSearchService.getPathById(props.columnModel.elementRef);
		assertNonNullable(path);
		const element = path ? documentModelSearchService.getByPath(path) : undefined;
		assertNonNullable(element);

		const fieldPath = useDocumentPathForInput(path, documentModel);
		const value = documentService.getAssignedObject(props.row ?? {}, fieldPath);

		if (element.type === "Field" && element.fieldType.type === "BooleanType") {
			return (
				<Checkbox
					fitToParent={false}
					style={{ minHeight: "auto", padding: 0 }}
					checked={!!value}
					readonly={readonly}
					onChange={newValue => {
						// Update field value in the corresponding document
						const originalRow = _.cloneDeep(props.row);
						dispatch(
							updateOverviewDocument({
								originalDocument: originalRow,
								activityId,
								updates: [[fieldPath, newValue as FieldInstanceValue | undefined]]
							})
						);
					}}
				/>
			);
		} else {
			return <DefaultComponentMap.TableBodyCell {...props} />;
		}
	};
}
